/**
 * Get supported card type from merchant config's payment constraints
 *  - paymentConstraints is an optional field in merchant config
 * @param {object} merchantConfig
 * @returns {array} supported card brands
 */
const getCardBrands = merchantConfig => {
  const paymentTypes = merchantConfig?.paymentConstraints?.paymentTypes?.paymentType ?? [];
  const cardBrands = (paymentTypes.length > 0 && paymentTypes.map(pType => pType.cardBrand)) || [];
  return cardBrands;
};
export default getCardBrands;
